//@flow
import * as Immutable from 'immutable';

import {
    validatable,
    validate,
    validateAll
} from 'common/utils/ValidationUtil';

import { VehicleLoadingParams } from 'common/models/flow/VehicleLoadingParams';
import type { VehicleLoadingParamsModelType } from 'common/models/flow/VehicleLoadingParams';

import DataUtils from 'common/utils/DataUtils';
import NumberUtils from 'common/utils/NumberUtils';

import I18nHelper from 'common/helpers/I18nHelper';

const translationsNamespace = ['entityManagement', 'validations'];
const nsTranslate = I18nHelper.getTranslate(translationsNamespace);

const validateNumber = (value: any) => {
    if (!DataUtils.isEmpty(value) && !NumberUtils.isNumeric(value)) {
        return nsTranslate(
            'validations:vehicleModelValidationErrors.notANumber'
        );
    }
};

@validatable
class InternalVehicleLoadingParams extends VehicleLoadingParams {
    static fromJS(
        json: VehicleLoadingParamsModelType
    ): InternalVehicleLoadingParams {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    @validate
    setLoadingDuration(loadingDuration: number): this {
        return super.setLoadingDuration(loadingDuration);
    }

    validateLoadingDuration() {
        return validateNumber(this.loadingDuration);
    }

    @validate
    setUnloadingDuration(unloadingDuration: number): this {
        return super.setUnloadingDuration(unloadingDuration);
    }

    validateUnloadingDuration() {
        return validateNumber(this.unloadingDuration);
    }

    @validateAll
    setAllValidationErrors(): this {
        return this;
    }
}

export { InternalVehicleLoadingParams as VehicleLoadingParams };
